import Api from "js/core/api";
import { loadImage } from "js/core/utilities/promiseHelper";
import { TaskState } from "common/constants";
import log from "js/core/logger";
import ApiError from "common/ApiError";
import pusher from "js/core/services/pusher";

/**
 * Fetches a signed url and loads the image from the url for the given slide
 * Note: timestamp is a parameter used only for the cache management purposes
 */
export async function getSignedUrlAndLoad(slideId, timestamp, presentationId = null, suffix = null, slideStageIndex = 0, ignoreCache = false) {
    log.info(log.THUMBNAIL)(`getSignedUrlAndLoad() slideId: ${slideId} timestamp: ${timestamp} presentationId: ${presentationId} suffix: ${suffix} slideStageIndex: ${slideStageIndex} ignoreCache: ${ignoreCache}`);

    const handleUrl = async url => {
        try {
            await loadImage(url);
        } catch (err) {
            if (ignoreCache) {
                throw new ApiError("Thumbnail not found", 404);
            }
            log.info(log.THUMBNAIL)(`getSignedUrlAndLoad() failed to load thumbnail for ${slideId} slide, fetching a new url without cache and trying again`);
            return this.getSignedUrlAndLoad(slideId, timestamp, presentationId, suffix, slideStageIndex, true);
        }
        return url;
    };

    const { url, channelId } = await Api.thumbnails.get({ slideId, slideStageIndex, timestamp, suffix, presentationId }, ignoreCache);
    if (url) {
        return handleUrl(url);
    }

    const event = await pusher.waitForEvent(channelId, TaskState.FINISHED, TaskState.ERROR, 2 * 60 * 1000);
    return handleUrl(event.url);
}

export default {
    getSignedUrlAndLoad
};
